import React from "react";
import { useTranslation } from "react-i18next";

import { createOauthClient } from "@admin/api/client";
import { showErrorToast, showSuccessToast } from "@shared/toasts/Toasts";

export const useCreateOauthClient = () => {
    const [data, setData] = React.useState<API.OauthClient | null>(null);
    const [isLoading, setIsLoading] = React.useState(false);

    const { t } = useTranslation(["pages"]);

    const onMutate = (client: API.OauthClient, onSuccess: (client: API.OauthClient) => void) => {
        setIsLoading(true);
        void createOauthClient(client)
            .then((response) => {
                setData(response.model);
                showSuccessToast(t("pages:adminOauthClientsPage.toast.oauthClientCreatedSuccess"));
                onSuccess(response.model);
            })
            .catch((error) => {
                const err = error as Error;
                showErrorToast(err.message);
            })
            .finally(() => setIsLoading(false));
    };

    return { data, isLoading, onMutate };
};
